import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row-top w-full" }
const _hoisted_2 = { class: "col w-full" }
const _hoisted_3 = { class: "row w-full mtop-10" }
const _hoisted_4 = { class: "col-0-8 colend mright-04" }
const _hoisted_5 = { class: "main-m font-m" }
const _hoisted_6 = { class: "row w-full mtop-10" }
const _hoisted_7 = { class: "col-0-8 colend mright-04" }
const _hoisted_8 = { class: "main-m font-m" }
const _hoisted_9 = { class: "rowcenter w-full mtop-10 gap-08" }

import { ref, onMounted, watch } from "vue";
import { AdminApi, LinkInstitutePersonRequest, InstituteLightResponse, PersonInstituteLightResponse } from '@/apiGenerate/medserver';
import { useI18n } from "vue-i18n";
import Select from 'primevue/select';
import Checkbox from 'primevue/checkbox';
import { ApiError } from "@/models/share.model";
import { medServerApiConfig } from "@/config/medserver-api.config";
import { toastError, toastSuccess } from "@/utils/toast-utils";
import { useToast } from "primevue";
import { InstituteRoleType } from "@/models/institute.model";


export default /*@__PURE__*/_defineComponent({
  __name: 'esAddInstitutePersonForm',
  props: {
    medicalPersonId: {},
    editingInstitute: {},
    editingIsAdmin: { type: Boolean }
  },
  emits: ["refresh"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();
const toast = useToast();

const adminApi = new AdminApi(medServerApiConfig);

const emit = __emit;

const linkInstitutePersonRequest = ref<LinkInstitutePersonRequest>({
    instituteId: undefined,
    addRoleAdmin: undefined
});

const confirmDisabled = ref<boolean>(false);
const instituteList = ref<InstituteLightResponse[]>([]);

const initForm = () => {
   linkInstitutePersonRequest.value = {
        instituteId: undefined,
        addRoleAdmin: undefined
    };
}

const getAllHealthProGroupInstitutes = () => {
    adminApi.searchInstitute({type: InstituteRoleType.HealthProGroup}).then((response: InstituteLightResponse[]) => {
        instituteList.value = response.sort((a, b) =>
            a.name.localeCompare(b.name, 'fr', { sensitivity: 'base' })
        );
    }).catch(() => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: t('error.DEFAULT')
        });
    });
}

const confirmForm = () => {
    if (linkInstitutePersonRequest.value.instituteId && props.medicalPersonId) {
       adminApi.linkInstituteAtPerson({personId: props.medicalPersonId, linkInstitutePersonRequest: linkInstitutePersonRequest.value}).then(() => {
            if(props.editingInstitute){
                toastSuccess(toast, {
                    summary: t('common.toast.success.add'),
                    detail:  t('admin.medicalPerson.institute.edit.message.success')
                });
            } else {
                toastSuccess(toast, {
                    summary: t('common.toast.success.add'),
                    detail:  t('admin.medicalPerson.institute.add.message.success')
                });
            }
            initForm();
            emit('refresh');
        }).catch((error: ApiError) => {
            if (error.status) {
                toastError(toast, {
                    summary: t('common.toast.error'),
                    detail: t(`error.${error.status}`)
                });
            } else {
                toastError(toast, {
                    summary: t('common.toast.error'),
                    detail: t('error.DEFAULT')
                });
            }
            
        });
    }
}

const cancelForm = () => {
    initForm();
}

onMounted(async () => {
    initForm();
    await getAllHealthProGroupInstitutes();
});

watch(
  () => props.editingInstitute,
  (newValue) => {
    if (newValue) {
      linkInstitutePersonRequest.value.instituteId = newValue.id;
      linkInstitutePersonRequest.value.addRoleAdmin = props.editingIsAdmin;
    } else {
      linkInstitutePersonRequest.value.instituteId = undefined;
    }
  },
  { immediate: true }
);



return (_ctx: any,_cache: any) => {
  const _component_es_button = _resolveComponent("es-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('admin.medicalPerson.institute.form.institute')), 1)
          ]),
          _createVNode(_unref(Select), {
            modelValue: linkInstitutePersonRequest.value.instituteId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((linkInstitutePersonRequest.value.instituteId) = $event)),
            options: instituteList.value,
            optionLabel: "name",
            "option-value": "id",
            size: "small",
            class: "w-full"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('admin.medicalPerson.institute.form.adminPermission')), 1)
          ]),
          _createVNode(_unref(Checkbox), {
            modelValue: linkInstitutePersonRequest.value.addRoleAdmin,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((linkInstitutePersonRequest.value.addRoleAdmin) = $event)),
            binary: ""
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_es_button, {
        label: _unref(t)('action.cancel'),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (cancelForm())),
        "is-primary": false
      }, null, 8, ["label"]),
      _createVNode(_component_es_button, {
        disabled: confirmDisabled.value,
        label: _unref(t)('action.save'),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (confirmForm())),
        "is-primary": true
      }, null, 8, ["disabled", "label"])
    ])
  ], 64))
}
}

})